import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getExpiryNotificationApi,  
  getAttendanceNotificationApi,
  getRecentActivitiesApi,
} from "../../apiservice/setting";

const HR_KEYWORDS = ["employee", "department", "designation", "client", "status"];

export const loadAllNotifications = createAsyncThunk(
  "notifications/loadAll",
  async (payload={}, thunkAPI) => {
    try {
      const [expRes, actRes, attRes] = await Promise.all([
        getExpiryNotificationApi({ onlyIncludeHr: payload.onlyIncludeHr }),
        getRecentActivitiesApi(),
        getAttendanceNotificationApi(),
      ]);

      const rawExp = expRes?.data?.data || [];
      const rawAct = actRes?.data?.data || [];
      const rawAtt = attRes?.data?.data || [];

      // UPCOMING EXPIRIES (transformed)
      const transformedExp = rawExp.flatMap((item) => {

  //  Detect type
  const isEmployee = !!item.employee_name;

    if (isEmployee) {
      return [
        {
          employee_name: item.employee_name,
          label: "Insurance Expiry In",
          days: item.days_until_insurance_expiry,
          type: "employee"
        },
        {
          employee_name: item.employee_name,
          label: "Labour Contract Expiry In",
          days: item.days_until_labour_contract_expiry,
          type: "employee"
        },
        {
          employee_name: item.employee_name,
          label: "E-ID / National ID Expiry In",
          days: item.days_until_national_id_expiry,
          type: "employee"
        },
        {
          employee_name: item.employee_name,
          label: "Visa Expiry In",
          days: item.days_until_visa_expiry,
          type: "employee"
        },
        {
          employee_name: item.employee_name,
          label: "Passport Expiry In",
          days: item.days_until_passport_expiry,
          type: "employee"
        },
        {
          employee_name: item.employee_name,
          label: "Birthday In",
          days: item.days_until_birth_date,
          type: "employee"
        },
        {
          employee_name: item.employee_name,
          label: "Client Labour Contract Expiry In",
          days: item.days_until_client_labour_contract_expiry,
          type: "employee"
        },
      ].filter(i => i.days !== null && i.days >= 0 && i.days <= 30);
    }

    //  Institution case
    const companyName = item.name || "Company";

    return [
      {
        employee_name: companyName,
        label: "Trade License Expiry",
        days: item.days_until_trade_license_expiry,
        type: "institution"
      },
      {
        employee_name: companyName,
        label: "DHA/MOH Expiry",
        days: item.days_until_dha_moh_expiry,
        type: "institution"
      },
      {
        employee_name: companyName,
        label: "GLN No Expiry",
        days: item.days_until_gln_no_expiry,
        type: "institution"
      },
      {
        employee_name: companyName,
        label: "Subscription Expiry",
        days: item.days_until_subscription_expiry,
        type: "institution"
      },
    ].filter(i => i.days !== null && i.days >= 0 && i.days <= 30);
  });

      const getAttendanceStatusText = (status) => {
        let statusText;

        switch (status) {
          case "pending":
            statusText = "Attendance awaiting approval";
            break;

          case "approved":
          case "inprogress":
          case "rejected":
            statusText = "Attendance updated";
            break;

          default:
            statusText = "Attendance updated";
        }
        return statusText;
      };

      const formatAttendanceType = (type) => {
        const map = {
          sick_leave: "Sick Leave",
          short_leave: "Short Leave",
          present: "Present",
          casual_leave: "Casual Leave",
          absence: "Absent",
          annual_leave: "Annual Leave",
          short_sick_leave: "Short Sick Leave",
          short_casual_leave: "Short Casual Leave",
        };

        return map[type] || type; // fallback safety
      };

      const transformedAttendance = rawAtt.map((att) => ({
        type: formatAttendanceType(att.attendance),
        employee_name: att.employee_name,
        status: getAttendanceStatusText(att.status),
        date: att.attendance_date,
        created_date: att.created_date,
      }));

      
      // HR FILTERING ONLY FOR DASHBOARD
      const hrActivities = rawAct.filter((act) =>
        HR_KEYWORDS.some((k) => act.activity_name?.toLowerCase().includes(k))
      );

      return {
        expiryList: transformedExp,
        expiryListHR: transformedExp.filter(e => e.type === "employee"),
        activityListAll: rawAct, // all activities
        activityListHR: hrActivities, // HR activities only
        attendanceList: transformedAttendance,
        count:
        rawExp.length +
        hrActivities.length +
        transformedAttendance.length,
        hrCount:
        transformedExp.filter(e => e.type === "employee").length +
        hrActivities.length +
        transformedAttendance.length,
      };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
